import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appFileUploadDragDrop]'
})
export class FileUploadDragDropDirective {
    private static readonly borderColorWhenDragHover = '#e2eefd';
    private static readonly borderColorWhenDragLeave = 'transparent';

    @Output() fileDropped = new EventEmitter<FileList>();

    constructor(private elRef: ElementRef) {}

    // Fixed
    @HostBinding('style.border-width') borderWidth = '2px';
    @HostBinding('style.border-style') borderStyle = 'dashed';

    // Dynamic
    @HostBinding('style.border-color') borderColor = FileUploadDragDropDirective.borderColorWhenDragLeave;

    @HostListener('dragenter', ['$event']) dragEnter(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        if (this.elRef.nativeElement.contains(event.relatedTarget) || this.elRef.nativeElement.contains(event.target)) {
            this.borderColor = FileUploadDragDropDirective.borderColorWhenDragHover;
        }
    }

    /**
     * The event will propagate to dragenter. Need to stop the event here.
     */
    @HostListener('dragover', ['$event']) dragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    /**
     * When mouse leaves from child element to parent element, this event is also fired.
     * It's essential to check the target is NOT a part of the host element.
     */
    @HostListener('dragleave', ['$event']) dragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.elRef.nativeElement.contains(event.relatedTarget) || !this.elRef.nativeElement.contains(event.target)) {
            this.borderColor = FileUploadDragDropDirective.borderColorWhenDragLeave;
        }
    }

    @HostListener('drop', ['$event']) drop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.borderColor = FileUploadDragDropDirective.borderColorWhenDragLeave;
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}
